import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CUSTOM_REPORT_FIELDS } from 'constants/customReportFields';
import { useCustomReportContext } from 'providers/CustomReportProvider';
import { Col, Form, Row } from 'react-bootstrap';
import DualListBox from '../components/DualListBox';
import FilterBuilder from '../components/FilterBuilder';

const DataAndFiltersStep = () => {
  const { reportData, updateColumns, updateFilters, updateReportData } =
    useCustomReportContext();

  const handleColumnsChange = selectedColumns => {
    updateColumns(selectedColumns);
  };

  const handleFiltersChange = filters => {
    updateFilters(filters);
  };

  const handleCheckboxChange = (field, value) => {
    updateReportData({
      [field]: value
    });
  };

  return (
    <>
      <h5 className="mb-2">Dados e Filtros</h5>
      <p className="text-muted mb-4 fs-11">
        Selecione as colunas a incluir no seu relatório e configure os filtros
        para refinar os dados.
      </p>

      {/* Column Selection */}
      <div className="mb-5">
        <div className="d-flex align-items-center mb-1">
          <h6 className="mb-0">Seleção de Colunas</h6>
          {reportData.columns.length === 0 && (
            <small className="ms-2 text-danger">
              <FontAwesomeIcon icon="exclamation-triangle" className="me-1" />
              Pelo menos uma coluna é obrigatória
            </small>
          )}
        </div>
        <p className="text-muted small mb-1 fs-11">
          Clique duas vezes para mover colunas entre as listas, ou use os botões
          de seta. A ordem das colunas selecionadas determinará sua ordem de
          exibição no relatório.
        </p>
        <DualListBox
          availableItems={CUSTOM_REPORT_FIELDS}
          selectedItems={reportData.columns}
          onChange={handleColumnsChange}
          availableTitle="Colunas Disponíveis"
          selectedTitle="Colunas Selecionadas"
        />
      </div>

      {/* Filter Configuration */}
      <div className="mb-4">
        <FilterBuilder
          filters={reportData.filters}
          onChange={handleFiltersChange}
        />
      </div>

      {/* Additional Options */}
      <Row>
        <Col md={12}>
          <h6 className="mb-1">Opções Adicionais</h6>
          <p className="text-muted small mb-1 fs-11">
            Estas opções, quando ativadas, irão incluir as anotações e
            apontamentos de cada ticket no JSON de integração do relatório.
          </p>
          <Form.Group className="mb-2">
            <Form.Check
              type="checkbox"
              id="include-ticket-notes"
              label="Incluir Anotações do Ticket"
              checked={reportData.includeTicketNotes}
              onChange={e =>
                handleCheckboxChange('includeTicketNotes', e.target.checked)
              }
            />
          </Form.Group>

          <Form.Group>
            <Form.Check
              type="checkbox"
              id="include-ticket-appointments"
              label="Incluir Apontamentos do Ticket"
              checked={reportData.includeTicketAppointments}
              onChange={e =>
                handleCheckboxChange(
                  'includeTicketAppointments',
                  e.target.checked
                )
              }
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default DataAndFiltersStep;
